import axios from 'axios';
import {
  calculateTotalSeconds,
  expiryTimeCalculation,
} from '../components/pages/authentication/two-factor-auth/couter';
import Toast from '../components/pages/utils/Toast';
import { API } from '../constants/Constants';
import Instance from './interceptor';
import {
  getLocalStorageItem,
  removeLocalStorageItem,
  setLocalStorageItem,
} from './localStorageUtils';

export const getCheckboxField = async (type) => {
  try {
    const response = await Instance.post(`${API.GET_CHECKBOX_DATA_FIELDS}`, {
      type,
    });
    if (response) {
      return await response?.data?.dataFieldWithStatus;
    }
  } catch (error) {
    return error;
  }
};

const localStorageAfterVerification = (response) => {
  setLocalStorageItem('role', response?.data?.roles[0]);
  setLocalStorageItem('RefreshToken', response?.data?.refreshToken);
  setLocalStorageItem('AccessToken', response?.data?.accessToken);
  setLocalStorageItem('SessionId', response?.data?.sessionId);
  setLocalStorageItem('UserId', response?.data?.id);
};

export const postCheckboxFIeldStatus = async (id, status) => {
  try {
    const response = await Instance.post(`${API.POST_CHECKBOX_DATA_FIELDS}`, {
      id,
      status,
    });

    if (response) {
      return response?.data;
    }
  } catch (error) {
    return error;
  }
};

export const selectAllCheckboxStatus = async (status, type) => {
  try {
    const response = await Instance.post(
      `${API.SELECT_ALL_CHECKBOX_DATA_FIELDS}`,
      {
        status,
        type,
      },
    );

    if (response) {
      return response?.data;
    }
  } catch (error) {
    return error;
  }
};

// get dropdown list
export const modelSelectDropBox = async () => {
  try {
    const response = await Instance.get(`${API.MODEL_SELECT_DROPBOX}`);
    if (response) {
      return response?.data;
    }
  } catch (error) {
    return error;
  }
};

// change ModelName
export const postModelName = async (modelName) => {
  try {
    const response = await Instance.post(`${API.POST_SELECTED_MODEL}`, {
      model: modelName,
    });
    if (response) {
      return response?.data;
    }
  } catch (error) {
    return error;
  }
};

// get ModelName  super admin
export const getModelNameForSA = async () => {
  try {
    const response = await Instance.get(`${API.GET_SELECTED_MODEL_FOR_SA}`);
    if (response) {
      return response?.data;
    }
  } catch (error) {
    return error;
  }
};

// change ModelName for super admin
export const postModelNameForSA = async (modelName) => {
  try {
    const response = await Instance.post(`${API.POST_SELECTED_MODEL_FOR_SA}`, {
      model: modelName,
    });
    if (response) {
      return response?.data;
    }
  } catch (error) {
    return error;
  }
};

// select default value of model
export const getTenantSetting = async () => {
  try {
    const response = await Instance.get(`${API.GET_SELECTED_MODEL}`);
    if (response) {
      return response?.data;
    }
  } catch (error) {
    Toast({ message: `${error.message}`, variant: 'error' });
  }
};

// change OTP-verification enable status
export const changeStatusTfa = async (isTfa) => {
  try {
    const response = await Instance.patch(`${API.CHANGE_TFA_STATUS}`, {
      isTfa,
    });
    return response?.data;
  } catch (error) {
    if (error?.response?.data?.errorMessage) {
      Toast({
        message: `${error?.response?.data?.errorMessage}`,
        variant: 'error',
      });
    } else if (error.message) {
      Toast({ message: `${error.message}`, variant: 'error' });
    }
  }
};

// verification of OTP
export const postOtp = async (otp) => {
  try {
    const email = getLocalStorageItem('email');

    const response = await axios.post(`${API.VERIFICATION_STATUS}`, {
      otp,
      email,
    });
    localStorageAfterVerification(response);
    removeLocalStorageItem('otp');
    removeLocalStorageItem('email');
    removeLocalStorageItem('OtpExp');
    return response?.data;
  } catch (error) {
    if (error?.response?.status === 400) {
      Toast({ message: `${error?.response?.data?.message}`, variant: 'error' });
      return error;
    }
  }
};

export const resendOtpApi = async () => {
  const email = getLocalStorageItem('email');
  try {
    const response = await axios.post(`${API.RESEND_OTP}`, { email });
    if (response) {
      const resendExpiry = response?.data?.otpexp;
      setLocalStorageItem('OtpExp', resendExpiry);
      const formattedDifference = expiryTimeCalculation();
      const secondsStr = calculateTotalSeconds(formattedDifference);
      Toast({
        message: `${response?.data?.message} to ${email}`,
        variant: 'success',
      });
      return secondsStr;
    }
  } catch (error) {
    Toast({ message: `${error?.response?.data?.message}`, variant: 'error' });
    return error;
  }
};

// update document duplication
export const updateDocumentDuplication = async (duplication) => {
  try {
    const response = await Instance.patch(`${API.UPDATE_DOCUMENT_DUPLICATE}`, {
      duplication,
    });
    if (response) {
      return response?.data;
    }
  } catch (error) {
    Toast({ message: `${error.message}`, variant: 'error' });
  }
};

export const updateManagersFCStatus = async (userIdsToSetTrue) => {
  try {
    const data = {
      userIdsToSetTrue,
    };
    const response = await Instance.patch(
      `${API.UPDATE_MANAGER_FC_STATUS}`,
      data,
    );
    if (response) {
      return response?.data?.message;
    }
  } catch (error) {
    Toast({ message: `${error.message}`, variant: 'error' });
  }
};

export const updateDocumentDetailsDuplication = async (duplication) => {
  try {
    const response = await Instance.patch(
      `${API.UPDATE_DOCUMENT_DUPLICATE_DETAILS}`,
      { duplication },
    );
    if (response) {
      return response?.data;
    }
  } catch (error) {
    Toast({ message: `${error.message}`, variant: 'error' });
  }
};
